import { render, staticRenderFns } from "./Parser.vue?vue&type=template&id=2dcb3706&scoped=true&"
import script from "./Parser.vue?vue&type=script&lang=js&"
export * from "./Parser.vue?vue&type=script&lang=js&"
import style0 from "./Parser.vue?vue&type=style&index=0&id=2dcb3706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb3706",
  null
  
)

export default component.exports